import { Suspense } from 'react';

import { IS_ANALYTICS_ENABLED } from '@monoimin/constants';
import { getProgramName } from '@monoimin/storyblok/getProgramName';

import { getPersonName } from '../../utils/getPersonName';
import {
  TrackPageViewClient,
  TrackPageViewProps,
} from '../TrackPageViewClient';

export const TrackPageView = async ({ data, ...props }: TrackPageViewProps) => {
  if (!IS_ANALYTICS_ENABLED) {
    return null;
  }

  const content = data?.content || {};

  // В новых тиках контента используется универсальный analytics блок вместо полей в каждом типе контента
  if (content && 'analytics' in content) {
    const analyticsBlock = content?.analytics?.[0];
    if (!analyticsBlock) return null;

    const {
      pageAuthor,
      pageExpert,
      pageInitiator: analyticsPageInitiator,
      investmentProgram,
    } = analyticsBlock;

    const authorName = pageAuthor ? await getPersonName(pageAuthor) : '';
    const expertName = pageExpert ? await getPersonName(pageExpert) : '';
    const programName = investmentProgram?.[0]
      ? await getProgramName({
          content: { investmentProgram: investmentProgram },
        })
      : '';

    return (
      <Suspense>
        <TrackPageViewClient
          {...props}
          data={data}
          authorName={authorName}
          expertName={expertName}
          programName={programName}
          pageInitiator={analyticsPageInitiator || props.pageInitiator}
        />
      </Suspense>
    );
  }

  // Для обычной статьи используем стандартные поля
  const {
    pageAuthor,
    pageExpert,
    pageInitiator: contentPageInitiator,
    investmentProgram,
  } = content;

  const authorName = pageAuthor ? await getPersonName(pageAuthor) : '';
  const expertName = pageExpert ? await getPersonName(pageExpert) : '';
  const programName = investmentProgram?.[0]
    ? await getProgramName({ content: { investmentProgram } })
    : '';

  return (
    <Suspense>
      <TrackPageViewClient
        {...props}
        data={data || {}}
        authorName={authorName}
        expertName={expertName}
        programName={programName}
        pageInitiator={contentPageInitiator || props.pageInitiator}
      />
    </Suspense>
  );
};
